'use strict';

var React = require('react');

var SvgNoteAddIcon = function SvgNoteAddIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 6.25c0-1.519 1.231-2.75 2.75-2.75h7.5c1.519 0 2.75 1.231 2.75 2.75v4.25c0 .414-.336.75-.75.75s-.75-.336-.75-.75v-4.25c0-.69-.56-1.25-1.25-1.25h-7.5c-.69 0-1.25.56-1.25 1.25v7.5c0 .69.56 1.25 1.25 1.25h4.25c.414 0 .75.336.75.75s-.336.75-.75.75h-4.25c-1.519 0-2.75-1.231-2.75-2.75v-7.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 12.25c.414 0 .75.336.75.75v1.25h1.25c.414 0 .75.336.75.75s-.336.75-.75.75h-1.25v1.25c0 .414-.336.75-.75.75s-.75-.336-.75-.75v-1.25h-1.25c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h1.25v-1.25c0-.414.336-.75.75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.55 7.25c0-.387.313-.7.7-.7h5.5c.387 0 .7.313.7.7 0 .387-.313.7-.7.7h-5.5c-.387 0-.7-.313-.7-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.25 9.05c-.387 0-.7.313-.7.7 0 .387.313.7.7.7h2.25c.387 0 .7-.313.7-.7 0-.387-.313-.7-.7-.7h-2.25Z"
  }));
};
SvgNoteAddIcon.displayName = "NoteAddIcon";

exports.SvgNoteAddIcon = SvgNoteAddIcon;
